import { useState, useEffect } from 'react';

const CONTENT_URL = import.meta.env.VITE_HOMEPAGE_CONTENT_URL;

// Module-level cache — shared across all callers, single fetch per page load.
let _cache = null;
let _promise = null;

function fetchContent() {
  if (_cache) return Promise.resolve(_cache);
  if (!_promise) {
    _promise = fetch(`${CONTENT_URL}?_t=${Date.now()}`)
      .then((r) => r.json())
      .then((json) => {
        _cache = json.components || [];
        return _cache;
      })
      .catch(() => {
        _promise = null;
        return [];
      });
  }
  return _promise;
}

export function useHomepageContent() {
  const [components, setComponents] = useState(_cache || []);

  useEffect(() => {
    if (!CONTENT_URL) return;
    fetchContent().then(setComponents);
  }, []);

  const find = (type) => components.find((c) => c.type === type)?.content ?? undefined;

  return {
    header:      find('header'),
    banner:      find('promoBanner'),
    footer:      find('footer'),
    bestSellers: find('bestSellers'),
    heroPromos:  find('heroPromoContainer'),
    ctaTiles:    find('ctaTiles'),
    contentBlock: find('contentBlock'),
  };
}
